/**
 * Digital Worker API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface WeightReportRequest {
  projectId: string;
  performedBy?: string;
  company?: string;
  discipline?: string;
  mainCategory: WeightReportRequest.MainCategoryEnum;
  areaTagSystem?: string;
  quantityMetres?: string;
  hoursSpent?: number;
  installedWeight?: string;
  removedWeight?: string;
  netWeightChange?: string;
  changeFollowUpRequired?: boolean;
  description?: string;
  comment?: string;
  recipientEmail?: string;
  selectedCategoryIds?: Array<string>;
}
export namespace WeightReportRequest {
  export const MainCategoryEnum = {
    AdditionalWork: 'ADDITIONAL_WORK',
    WeightChange: 'WEIGHT_CHANGE',
    Other: 'OTHER',
  } as const;
  export type MainCategoryEnum = (typeof MainCategoryEnum)[keyof typeof MainCategoryEnum];
}
